/**
 * Maps a CONSTRUCTOR graft model node to ConstructorData: type, name, and parameters (name + formatted type).
 * CONSTRUCTOR payload: [CLASS_NAME, MODIFIER, PARAMETERS_ARRAY]
 */

import type { Constructor, ConstructorData, Parameter, ParametersArray } from '@/core/types/library.type'

import { CONSTRUCTOR } from '../../const/graftModelPayload.const'
import { getUnifiedGraftModelType } from '../getUnifiedGraftModelType'

import { formatTypeUsage, getIsNullableFromTypeUsage, getPrimitiveTypeFromTypeUsage } from './formatTypeUsage'
import { parseParameterPayload } from './parseParameterPayload'
import { safeString } from './safeString'

export const mapConstructor = (item: Constructor): ConstructorData => {
  const p = item.payload
  const parametersArray = (p[CONSTRUCTOR.PARAMETERS] as ParametersArray | undefined) ?? { payload: [] }
  const parameters = parametersArray.payload

  return {
    type: getUnifiedGraftModelType(
      item as { unifiedGraftModelType?: unknown; graftModelType?: unknown }
    ) as ConstructorData['type'],
    name: safeString(p[CONSTRUCTOR.CLASS_NAME]),
    parameters: parameters.map((param: Parameter) => {
      const { typeUsage, name: paramName } = parseParameterPayload(param)
      const isNullable = getIsNullableFromTypeUsage(typeUsage)
      return {
        name: paramName,
        type: formatTypeUsage(typeUsage),
        isNullable,
        isNullabel: isNullable,
        primitiveType: getPrimitiveTypeFromTypeUsage(typeUsage),
        typeUsage,
      }
    }),
  }
}
